import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import fs from 'fs';
import JSZip from 'jszip';

import { 
  Button, 
  Dialog, 
  ListItem, 
  List, 
  Divider, 
  MenuItem,
  AppBar, 
  Toolbar, 
  IconButton, 
  Typography, 
  Slide,
  TextField,
  Card,
  CardHeader,
  CardContent,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import { toast } from 'react-toastify';

import { IsNoU } from 'common/utils';

import { playerApkTypes } from 'common/datas';

const useStyles = makeStyles(theme => ({
  content: {
    marginTop: theme.spacing(2)
  },
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  card_header: {
    backgroundColor: theme.palette.card_header,
  },
  listitem_align: {
    //alignItems: 'center',
  },
  registerListItemTitle: {
    marginLeft: theme.spacing(2),
    width: '100px',
  },
  registerListItemInput: {
    //marginLeft: theme.spacing(2),
    width: '240px',
    //height: '40px',
  },
  registerListItemFilePath: {
    //marginLeft: theme.spacing(2),
    width: '320px',
  },
  registerListItemUpload: {
    marginLeft: theme.spacing(2),
  },
}));
  

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


const RegAndEditPlayer = (props) => {

  const {
    className,
    openDialog,
    onClickCloseDialog,
    onClickSavePlayer,
    editPlayer,
    modeRegisterDlg,
    userName,
  } = props;

  const classes = useStyles();

  

  const [playerName, setPlayerName] = useState('');
  const [apkFile, setApkFile] = useState(null);
  const [apkFileSize, setApkFileSize] = useState(0);
  const [apkFileName, setApkFileName] = useState('');
  const [prevApkFile, setPrevApkFile] = useState('');
  const [selectedMeter, setSelectedMeter] = useState('');
  const [versionCode, serVersionCode] = useState(0);
  const [playerDescription, setPlayerDescription] = useState('');

  const toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

  const getPackageName = async (file) => {

    //JSZip.loadAsync(data)
    // const promisseRead = new JSZip.external.Promise(function (resolve, reject) {
      
    // }).then(function (data) {
    //     return JSZip.loadAsync(data);
    // })
//    .then(...)

    // const convertFileToBase64 = file => new Promise((resolve, reject) => {
    //   const reader = new FileReader();
    //   reader.readAsDataURL()

    //   reader.onload = () => resolve({
    //       fileName: file.title,
    //       base64: reader.result
    //   });
    //   reader.onerror = reject;
    // });

    
    //var file = event.target.files[0];
    // let apkBlobAsByteArray = await (async function (blob) {
    //   const slice = blob.slice();
    //   console.log(slice);
    //   // Blob {size: 12, type: ""}
    //   const stream = blob.stream();
    //   console.log(stream);
    //   // ReadableStream {locked: false}
    //   const text = await blob.text();
    //   console.log(text);
    //   // 😀test txt
    //   const arrayBuffer = await blob.arrayBuffer();
    //   console.log(arrayBuffer);
    //   // ArrayBuffer(12) {}
    //   //   Int8Array(7498)
    //   //   Int16Array(3749)
    //   //   Uint8Array(7498)
    //   //   byteLength: 7498
    //   return text;
    // })(file);

    //const apkBlobAsByteArray = await toBase64(file);

    //const apkBlobAsByteArray = await Promise.all[promisseRead];

    //console.log(apkBlobAsByteArray);

    // Unzipping zip blob
    //var zip = new JSZip(apkBlobAsByteArray);
    var zip = new JSZip();
    var zip_load = await zip.loadAsync(file);
                          // .then(zip => {
                          //   zip.file('AndroidManifest.xml').async('string');
                          // });
    console.log(zip_load);

    // Getting AndroidManifest.xml and decompress it
    var androidCompress = zip_load.files['AndroidManifest.xml'];
    console.log(androidCompress);
    var androidNonCompress = androidCompress._data.getContent();

    // Reading to content to a searchable string
    var packageNameArray = [];
    var textArray = String(androidNonCompress).split(',');
    for (var i = 0, len = textArray.length; i < len; i++) {
        if (textArray[i] !== 0) {
            packageNameArray.push(textArray[i]);
        }
    }

    // Searching for package name
    var startPattern = 'manifest';
    var androidText = String.fromCharCode.apply(null, packageNameArray).toString().toLowerCase();
    var packageName = androidText.substring(androidText.indexOf(startPattern) +
        startPattern.length, androidText.indexOf('uses'));
    // Remove version from package name
    packageName = packageName.substring(0, packageName.indexOf(packageName.match(/\d+/)[0]));

    return packageName;
}

  useEffect(() => {
  
    if (editPlayer === null) {
      setPlayerName('');
      setApkFile(null);
      
      setPrevApkFile('');
      setSelectedMeter('');
      serVersionCode(0);
      setPlayerDescription('');
    }
    else {
      setPlayerName(editPlayer.name);
      setApkFile(null);
      setPrevApkFile(editPlayer.file);
      setSelectedMeter(editPlayer.meter_type);
      serVersionCode(editPlayer.version_code);
      setPlayerDescription(editPlayer.description);
    }

    setApkFileSize(0);

  }, [editPlayer]);

  const renderNewPlayer = (
    <ListItem>
      <TextField 
        className={classes.registerListItemInput}
        required 
        id="outlined-basic1" 
        //variant="outlined" 
        label="파일 첨부"
        //placeholder="플레이어 이름을 입력하세요..."
        fullWidth
        value={apkFileName}
        disabled={true}
        //onChange={event=> setPlayerName(event.target.value)}
        />
      <Button
        className={classes.registerListItemUpload}
        variant="contained"
        component="label"
      >
        파일선택
        <input
          type="file"
          accept=".apk"
          style={{ display: "none" }}
          onChange={e => {
            const file = e.target.files[0];
            if (file !== null && file !== undefined) {
            // console.log('player-package-name -> ' + getPackageName(file));
            setApkFile(file);
            setApkFileSize(file.size);
            setApkFileName(file.name);
            }
            //console.log(file);
          }}
        />
      </Button>
    </ListItem>
  );

  const renderEditPlayer = (
    <>
      <ListItem >
        <TextField 
          className={classes.registerListItemInput}
          required 
          id="id_prev_file" 
          //variant="outlined" 
          label="파일 첨부"
          //placeholder="플레이어 이름을 입력하세요..."
          fullWidth
          value={prevApkFile}
          disabled={true}
          //onChange={event=> setPlayerName(event.target.value)}
          />
      </ListItem>
      <ListItem>
        <TextField 
          className={classes.registerListItemInput}
          required 
          id="id_new_file" 
          //variant="outlined" 
          label="신규 파일"
          //placeholder="플레이어 이름을 입력하세요..."
          helperText="기존등록파일명이 같을경우 신규수정파일 등록 불가 합니다"
          fullWidth
          value={apkFileName}
          disabled={true}
          //onChange={event=> setPlayerName(event.target.value)}
          />
        <Button
          className={classes.registerListItemUpload}
          variant="contained"
          component="label"
        >
          파일선택
          <input
            type="file"
            accept=".apk"
            style={{ display: "none" }}
            onChange={e => {
              const file = e.target.files[0];
              if (file !== null && file !== undefined) {
                let fileName = file.name.toString();
                let prevName = undefined;
                if (!IsNoU(prevApkFile) && prevApkFile.length > 0) {
                  prevName = prevApkFile.toString();
                }
                if (!IsNoU(prevName) && fileName === prevName) {
                  setApkFile(null);
                  setApkFileSize(0);
                  setApkFileName('');
                  toast('기존 등록 파일명과 동일합니다.');
                }
                else {
                  setApkFile(file);
                  setApkFileSize(file.size);
                  //console.log('file_size -> ' + file.size);
                  setApkFileName(file.name);
                }
              }
              //const file = e.target.files[0];
              
              //console.log(file);
            }}
          />
        </Button>
      </ListItem>
    </>
  );

  return (
    <Dialog fullScreen open={openDialog} onClose={onClickCloseDialog} TransitionComponent={Transition}>
      <AppBar className={classes.appBar}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={onClickCloseDialog} aria-label="close">
            <CloseIcon />
          </IconButton>
          <Typography variant="h5" className={classes.title} color="inherit">
            플레이어
          </Typography>
          <Button autoFocus color="inherit" onClick={() => {
            
            if (IsNoU(playerName) || playerName.length <= 0) {
              toast('플레이어 이름을 입력하세요');
              return ;
            }

            if (apkFile === null) {
              toast('플레이어 파일을 선택하세요');
              return ;
            }

            if (IsNoU(selectedMeter) || selectedMeter.length <= 0) {
              toast("미터기 종료를 선택하세요.");
              return ;
            }

            // if (IsNoU(playerDescription) || playerDescription.length <= 0) {
            //   toast('플레이어 설명을 입력하세요');
            //   return ;
            // }

            const newPlayer = {
              name: playerName,
              file: apkFile,
              file_size: apkFileSize,
              meter_type: selectedMeter,
              version_code: versionCode,
              modified_user: userName,
              modified_at: new Date(),
              description: playerDescription,
              prev_file: prevApkFile,
            };

            if (!IsNoU(editPlayer))
              newPlayer.id = editPlayer.id;

            onClickSavePlayer(newPlayer);
          }}>
            저장
          </Button>
        </Toolbar>
      </AppBar>

      <List>
        <ListItem className={classes.listitem_align}>
        <Card
          className={clsx(classes.card_root, className)}
        >
          <CardHeader
            className={classes.card_header}
            title={modeRegisterDlg ? '플레이어 등록' : '플레이어 수정'}
            subheader='*표시는 필수 항목'
          />
          <CardContent className={classes.content}>
            <List>
              <ListItem className={classes.listitem_align}>
                <TextField 
                      className={classes.registerListItemInput}
                      required 
                      id="outlined-basic1" 
                      //variant="outlined" 
                      label="플레이어 이름"
                      placeholder="플레이어 이름을 입력하세요..."
                      fullWidth
                      value={playerName}
                      onChange={event=> setPlayerName(event.target.value)}
                      />
              </ListItem>
              <Divider />
              { modeRegisterDlg ? renderNewPlayer : renderEditPlayer }
              <Divider />
                <ListItem>
                  <TextField
                    className={classes.registerListItemInput}
                    id="outlined-select-meter"
                    label='APK 타입'
                    select
                    required
                    value={selectedMeter}
                    onChange={event=> setSelectedMeter(event.target.value)}
                    helperText=""
                    //variant="outlined"
                    margin="dense"
                  >
                    {playerApkTypes.map(option => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>

                </ListItem>
              <ListItem className={classes.listitem_align}>
                <TextField 
                      className={classes.registerListItemInput}
                      required 
                      id="outlined-basic1" 
                      //variant="outlined" 
                      label="VERSION CODE"
                      placeholder="VERSION CODE를 입력하세요..."
                      fullWidth
                      value={versionCode}
                      onChange={event=> serVersionCode(Number(event.target.value))}
                      />
              </ListItem>
              <Divider />
              <ListItem>
                <TextField 
                  className={classes.registerListItemInput}
                  //required 
                  id="id_player_description" 
                  //variant="outlined" 
                  label="플레이어 설명"
                  placeholder="플레이어 설명을 입력하세요..."
                  fullWidth
                  value={playerDescription}
                  onChange={event=> setPlayerDescription(event.target.value)}
                  />
              </ListItem>
            </List>
          </CardContent>
          </Card>
        </ListItem>
      </List>
    </Dialog>
  );
}

export default RegAndEditPlayer;